import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: {
	readonly loginButton: {
		readonly id: 'twg-microsite.navbar.loginButton';
		readonly defaultMessage: 'Log in';
		readonly description: 'Button to log in to the application';
	};
	readonly loginAriaLabel: {
		readonly id: 'twg-microsite.navbar.loginAriaLabel';
		readonly defaultMessage: 'Log in';
		readonly description: 'Accessible label for the log in button';
	};
	readonly userAccountMenuAriaLabel: {
		readonly id: 'twg-microsite.navbar.userAccountMenuAriaLabel';
		readonly defaultMessage: 'Account menu, {userName}';
		readonly description: 'Accessible label for the signed-in user avatar that opens the account menu. {userName} is the user display name.';
	};
	readonly teamworkGraphBrand: {
		readonly id: 'twg-microsite.navbar.teamworkGraphBrand.do-not-translate';
		readonly defaultMessage: 'Atlassian Teamwork Graph';
		readonly description: 'Teamwork Graph brand name shown in the nav bar';
	};
	readonly navAbout: {
		readonly id: 'twg-microsite.navbar.navAbout';
		readonly defaultMessage: 'About';
		readonly description: 'Navigation link to the About section of the microsite';
	};
	readonly navConnectors: {
		readonly id: 'twg-microsite.navbar.navConnectors';
		readonly defaultMessage: 'Connectors';
		readonly description: 'Navigation link to the Connectors section of the microsite';
	};
	readonly navCli: {
		readonly id: 'twg-microsite.navbar.navCli.do-not-translate';
		readonly defaultMessage: 'CLI';
		readonly description: 'Navigation link to the CLI section of the microsite';
	};
	readonly navMcp: {
		readonly id: 'twg-microsite.navbar.navMcp.do-not-translate';
		readonly defaultMessage: 'MCP';
		readonly description: 'Navigation link to the Getting Started section of the microsite, pre-selecting the MCP install instructions tab';
	};
	readonly navDocs: {
		readonly id: 'twg-microsite.navbar.navDocs';
		readonly defaultMessage: 'Docs';
		readonly description: 'Navigation link to the documentation section of the microsite';
	};
	readonly navYourGraph: {
		readonly id: 'twg-microsite.navbar.navYourGraphs';
		readonly defaultMessage: 'Your Graph';
		readonly description: 'Navigation link to the Your Graphs section of the microsite';
	};
	readonly profileLabel: {
		readonly id: 'twg-microsite.navbar.profileLabel';
		readonly defaultMessage: 'Profile';
		readonly description: 'Label and icon label for the Profile menu item in the user dropdown';
	};
	readonly logoutLabel: {
		readonly id: 'twg-microsite.navbar.logoutLabel';
		readonly defaultMessage: 'Logout';
		readonly description: 'Label and icon label for the Logout menu item in the user dropdown';
	};
	readonly logoAlt: {
		readonly id: 'twg-microsite.navbar.logoAlt';
		readonly defaultMessage: 'Teamwork Graph logo';
		readonly description: 'Accessible label for the Teamwork Graph logo';
	};
} = defineMessages({
	loginButton: {
		id: 'twg-microsite.navbar.loginButton',
		defaultMessage: 'Log in',
		description: 'Button to log in to the application',
	},
	loginAriaLabel: {
		id: 'twg-microsite.navbar.loginAriaLabel',
		defaultMessage: 'Log in',
		description: 'Accessible label for the log in button',
	},
	userAccountMenuAriaLabel: {
		id: 'twg-microsite.navbar.userAccountMenuAriaLabel',
		defaultMessage: 'Account menu, {userName}',
		description:
			'Accessible label for the signed-in user avatar that opens the account menu. {userName} is the user display name.',
	},
	teamworkGraphBrand: {
		id: 'twg-microsite.navbar.teamworkGraphBrand.do-not-translate',
		defaultMessage: 'Atlassian Teamwork Graph',
		description: 'Teamwork Graph brand name shown in the nav bar',
	},
	navAbout: {
		id: 'twg-microsite.navbar.navAbout',
		defaultMessage: 'About',
		description: 'Navigation link to the About section of the microsite',
	},
	navConnectors: {
		id: 'twg-microsite.navbar.navConnectors',
		defaultMessage: 'Connectors',
		description: 'Navigation link to the Connectors section of the microsite',
	},
	navCli: {
		id: 'twg-microsite.navbar.navCli.do-not-translate',
		defaultMessage: 'CLI',
		description: 'Navigation link to the CLI section of the microsite',
	},
	navMcp: {
		id: 'twg-microsite.navbar.navMcp.do-not-translate',
		defaultMessage: 'MCP',
		description:
			'Navigation link to the Getting Started section of the microsite, pre-selecting the MCP install instructions tab',
	},
	navDocs: {
		id: 'twg-microsite.navbar.navDocs',
		defaultMessage: 'Docs',
		description: 'Navigation link to the documentation section of the microsite',
	},
	navYourGraph: {
		id: 'twg-microsite.navbar.navYourGraphs',
		defaultMessage: 'Your Graph',
		description: 'Navigation link to the Your Graphs section of the microsite',
	},
	profileLabel: {
		id: 'twg-microsite.navbar.profileLabel',
		defaultMessage: 'Profile',
		description: 'Label and icon label for the Profile menu item in the user dropdown',
	},
	logoutLabel: {
		id: 'twg-microsite.navbar.logoutLabel',
		defaultMessage: 'Logout',
		description: 'Label and icon label for the Logout menu item in the user dropdown',
	},
	logoAlt: {
		id: 'twg-microsite.navbar.logoAlt',
		defaultMessage: 'Teamwork Graph logo',
		description: 'Accessible label for the Teamwork Graph logo',
	},
} as const) satisfies Record<string, MessageDescriptor>;
